import type { FaireProductEntity } from "../../entity_types/product";

export const p_g4p5euhdhu: FaireProductEntity = {
  token: "p_g4p5euhdhu",
  type: "product",
  name: "Sequoia National Park T-shirt - USA Made | 100% Cotton",
  brandToken: "b_c251hgcw2g",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/0d88e1d09f4492a63ac973827f0a8cf313c9276966f3b35a282afbc7c639b902.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/029a426771bc77abe9d1815b41b4935185df35c0286c449c16985fdd4aa4780b.jpeg",
  ],
  priceDollars: 25.64,
  description:
    "You'll love this super soft Sequoia National Park tee, featuring a hand illustrated image. Artwork is slightly distressed, printed in Los Angeles, and sits on a soft vintage style tee.\n\n• 100% Cotton\n• Sizing is Unisex\n• Garment Dyed\n• Made in USA\n\n\n\nNational Parks | Hiking | Backpacking | Travel | Fashion | Contemporary | California | Sustainable | Eco-Friendly | Small Batch | Sequoia",
  tags: [],
  msrpDollars: 51.27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:40.339Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
